<button
  *ngIf="isVisible"
  type="button"
  class="hgb"
  [class.hgb--labelled]="labelled"
  (click)="replay()"
  [matTooltip]="('ONBOARDING_TOUR.COMMON.REPLAY' | translate) + ' — ' + (guide!.labelKey | translate)"
  matTooltipClass="cl-action-tooltip"
  [matTooltipShowDelay]="200"
  matTooltipPosition="below"
  [attr.aria-label]="'ONBOARDING_TOUR.COMMON.REPLAY' | translate"
>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
  <span *ngIf="labelled">{{ 'ONBOARDING_TOUR.COMMON.REPLAY' | translate }}</span>
</button>
